import * as React from "react";
import { useEffect, useState, useContext } from "react";

import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import WorkIcon from "@mui/icons-material/Work";
import ChevronRightSharpIcon from "@mui/icons-material/ChevronRightSharp";
import { Tooltip } from "@mui/material";


import { useHistory } from "react-router";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { ProvidersAffiliateOrders, USER, SERVICE_NAME_OFFLINE_CONSULTS, HAMBURGER_NO_CODE_URL, labsTabs, visionTabs } from "../../constants/provider/constant";
import { How_To_Use_Video_Maps, offlineConsultsTabs } from "../../components/centralOms/common/constants";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { HowToUse } from "../../components/centralOms/common/howToUseDialog";
import { getUserDetails, getUserAddress, getAccessToken, getUserFeatureKey } from "../../auth/common";
import { ODIcon } from "../../components/DoctorMangement/ODIcon";
import { getFeaturesForUser } from "../../components/SPOC/Helper/utils";
import UserFeaturesContext from "../../hook/UserDetails/UserFeaturesContext";
import { isArguments } from "lodash";
import { isInaccessible } from "@testing-library/react";
import { generateResetPasswordLink } from "../../components/SPOC/Helper/API";
import { ToastEmitter } from "../../components/DoctorMangement/ToastEmitter";
import { BackdropLoader } from "../../components/DoctorMangement/BackdropLoader";
export default function NestedList(props) {
  const history = useHistory();
  const [open, setOpen] = React.useState(true);
  const [openHTU, setOpenHTU] = React.useState(false);
  const entityName = getUserDetails()?.entityName;
  const [howToUseDialogVisible, setHowToUseDialogVisibiliy] = React.useState(false);
  const [videoURL, setVideoURL] = React.useState("");
  const [doctorManagementTabsCollapse, setDoctorManagementTabsCollapse] = React.useState(false);
  const [SPOCManagementTabsCollapse, setSPOCManagementTabsCollapse] = React.useState(false);
  const [listingOfServiceOFC, setListingOfServiceOFC] = React.useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const { userFeatures, saveUserFeatures } = useContext(UserFeaturesContext);
  const How_To_Use_Video_Map = How_To_Use_Video_Maps();



  const getProviderId = () => {
    const loggedUser = getUserDetails();
    const loggedProviderId = (loggedUser.providerId || loggedUser.parentId);
    return loggedProviderId;
  }




  const user_details = getUserDetails();
  const providerId = getProviderId();
  const providerAddress = getUserAddress();

  React.useEffect(() => {
    let validService = localStorage.getItem('ValidServices');
    validService = typeof validService === 'string' ? JSON.parse(validService) : validService;

    if (validService.includes(SERVICE_NAME_OFFLINE_CONSULTS) ) {
      setListingOfServiceOFC(true);
    }
  }, [props])

  const lists =
    props.service == "LABS"
      ? labsTabs
      : props.service == "VISION"
      ? visionTabs
      : offlineConsultsTabs;

      const DoctorManagementTabs =
   [
      { id: 1, name: "Doctor List", route: '/offlineConsults/DoctorManagement', isAccesible: (userFeatures && userFeatures.length > 0 && userFeatures.includes('VIEW_OFFLINE')), featureName:'VIEW_OFFLINE'},
      { id: 2, name: "Add New Doctor", route: "/offlineConsults/DoctorManagements", isAccesible: (userFeatures && userFeatures.length > 0 && userFeatures.includes('UPDATE_DOCTOR')), featureName:'UPDATE_DOCTOR' },
    ];

    const SPOCMangemnetsTabs = [
      { id: 1, name: "SPOC List", route: '/SPOC/SPOCManagement', isAccesible: (userFeatures && userFeatures.length > 0 && userFeatures.includes('VIEW_SPOC_LIST')), featureName :'VIEW_SPOC_LIST' },
      { id: 2, name: "Add New SPOC", route: "/SPOC/SPOCManagements", isAccesible: (userFeatures && userFeatures.length > 0 && userFeatures.includes('CREATE_SPOC')), featureName: 'CREATE_SPOC' },
    ];

    useEffect(()=>{
      if(userFeatures){
        SPOCMangemnetsTabs.forEach((item)=>{
          item.isAccesible = (userFeatures && userFeatures.length > 0 && userFeatures.includes(item.featureName));
        })
        DoctorManagementTabs.forEach((item)=>{
          item.isAccesible = (userFeatures && userFeatures.length > 0 && userFeatures.includes(item.featureName));
        })
      }
    },[userFeatures])

  const routesTo = (route) => {
    if (props.service == "LABS") {
      history.push("/" + localStorage.getItem("roleName") + route);
    } else {
      history.push(route);
    }
    props.toggleDrawerFunction();
  };

  const redirectToLink = (route) => {
    history.push(route);
    props.toggleDrawerFunction();
  };

  const redirectToUrl = (url) => {
    let accesstoken = getAccessToken();
    accesstoken = typeof accesstoken === 'string' ? JSON.parse(accesstoken) : accesstoken;
    const userFeatureKey = getUserFeatureKey();
    const userFeatureKeyUriEncoded = encodeURIComponent(userFeatureKey);
    url = url + `?accesstoken=${accesstoken}&userFeatures=${userFeatureKeyUriEncoded}`;
    window.open(url, "_blank");
  };

  const handleClick = () => {
    setOpen(!open);
  };
  
  useEffect(() => {
    const saveUserFeaturesInContextHook = async () => {
      if (userFeatures) return;
      const {userFeature, userRoles} = await getFeaturesForUser(history)
      saveUserFeatures(userFeature, userRoles);
    }
    saveUserFeaturesInContextHook();
  }, []);

  const roleName = localStorage.getItem("roleName");


  const triggerResetPasswordLink = async () => {
    try {
      setIsLoading(true)
      const resp = await generateResetPasswordLink(user_details.userName);
      ToastEmitter(`Password Reset Link has be sent to the registered Email Id ${resp.emailId}`)
    }
    catch (err) {
      ToastEmitter("Unable To reset password Please Try after some time", 'error')
    }
    finally {
      setIsLoading(false)
    }
  }


  return (
    <>{isLoading && <BackdropLoader isLoading={isLoading} />}
    <div className="flex flex-col justify-between min-h-screen">
      <List
        aria-labelledby="nested-list-subheader"
        subheader={
          entityName ? (
            <ListSubheader component="div" className="p-0" id="nested-list-subheader" sx={{ padding: 0 }}>
              <div
                className="font-semibold bg-nested-menu-header leading-tight pt-4 pb-6 px-4"
              >
                <div className="flex items-center gap-1">
                <div>{entityName}</div>
                  <Tooltip
                    title={<span>{providerAddress}</span>}
                    arrow
                  >
                    <span className=" flex items-center justify-center cursor-pointer px-1" style={{ minWidth: "2.5rem", minHeight: "1.5rem" }}>
                      <ODIcon
                        src="/assets/info.svg"
                        width={22}
                        height={22}
                        className="inline-block"
                        alt="Info"
                      />
                    </span>
                  </Tooltip>
                </div>
                <p className="pt-2">Provider ID: {providerId}</p>
                 <p className="pt-2">   Contact our support <br/>at +91 99999 91555 for help. </p>
              </div>
            </ListSubheader>
          ) : (
            ""
          )
        }
      >
        <ListItemButton>
          {roleName === "dcadmin" ? (
            <ListItemIcon onClick={() => history.push("/dashboard")}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Admin Dashboard" />
            </ListItemIcon>
          ) : (
            <></>
          )}
        </ListItemButton>
        <ListItemButton onClick={handleClick}>
          <ListItemIcon>
            <WorkIcon />
          </ListItemIcon>
          <ListItemText primary="Appointments" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {lists ? (
              lists.map((elem, index) => (
                <ListItemButton key={index} sx={{ pl: 3 }} onClick={() => routesTo(elem.route)}>
                  <ListItemIcon>
                    <ChevronRightSharpIcon />
                  </ListItemIcon>
                  <span className="text-sm">{elem.name}</span>
                </ListItemButton>
              ))
            ) : (
              <></>
            )}
          </List>
        </Collapse>

        {listingOfServiceOFC && <>
          <ListItemButton onClick={() => { setDoctorManagementTabsCollapse(!doctorManagementTabsCollapse) }}>
            <ListItemIcon>
            <ODIcon src="/assets/Doctor.svg" height="32px" width="32px" alt=""/>
            </ListItemIcon>
            <ListItemText primary="Manage Doctor" />
            {doctorManagementTabsCollapse ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={doctorManagementTabsCollapse} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {DoctorManagementTabs ? (
                DoctorManagementTabs.map((elem, index) => (
                  <>
                    {
                      elem.isAccesible &&
                      <ListItemButton key={index} sx={{ pl: 3 }} onClick={() => redirectToLink(elem.route)}>
                        <ListItemIcon>
                        </ListItemIcon>
                        <span className="text-sm">{elem.name}</span>
                      </ListItemButton>
                    }
                  </>
                ))
              ) : (
                <></>
              )}
            </List>
          </Collapse>
        </>
        }

          <ListItemButton onClick={() => { setSPOCManagementTabsCollapse(!SPOCManagementTabsCollapse) }}>
            <ListItemIcon>
           <ODIcon src="/assets/SPOC.svg" height="32px" width="32px" alt=""/>
            </ListItemIcon>
            <ListItemText primary="Manage SPOCs" />
            {SPOCManagementTabsCollapse ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={SPOCManagementTabsCollapse} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {SPOCMangemnetsTabs ? (
                SPOCMangemnetsTabs.map((elem, index) => (
                  <>
                    { elem.isAccesible &&
                      <ListItemButton key={index} sx={{ pl: 3 }} onClick={() => redirectToLink(elem.route)}>
                        <ListItemIcon>
                        </ListItemIcon>
                        <span className="text-sm">{elem.name}</span>
                      </ListItemButton>
                    }
                  </>
                ))
              ) : (
                <></>
              )}
            </List>
          </Collapse>

        {
          HAMBURGER_NO_CODE_URL.map((elem, index) => (
            <ListItemButton onClick={() => redirectToUrl(elem.route)}>
              <ListItemIcon>
                <ODIcon src="/assets/extrenalLink.svg" height="32px" width="32px" alt="ExternalLink" />
              </ListItemIcon>
              <ListItemText primary={elem.name} />
            </ListItemButton>
          ))
        }

        <ListItemButton onClick={() => setOpenHTU(!openHTU)}>
          <ListItemIcon>
            <PlayCircleIcon />
          </ListItemIcon>
          <ListItemText primary="How To Use" />
          {openHTU ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openHTU} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {Object.keys(How_To_Use_Video_Map).map((elem, index) => (
              <ListItemButton key={index} sx={{ pl: 3 }} 
                onClick={() => {
                  setHowToUseDialogVisibiliy(true); 
                  setVideoURL(How_To_Use_Video_Map[elem].videoUrl);
                }
              }>
                <ListItemIcon>
                  <ChevronRightSharpIcon />
                </ListItemIcon>
                <span className="text-sm">{How_To_Use_Video_Map[elem].name}</span>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        {ProvidersAffiliateOrders.includes(providerId) && (
          <ListItemButton onClick={() => routesTo("/create/order")}>
            <ListItemIcon>
              <AddCircleRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Create Order" />
          </ListItemButton>
        )}
      </List>

          {howToUseDialogVisible && <HowToUse visible={howToUseDialogVisible} setVisibility={setHowToUseDialogVisibiliy} videoURL={videoURL}></HowToUse>}

      <div className=" pt-4 pb-6 px-4 gap-2 flex flex-col">
        <div className="flex flex-start gap-2 cursor-pointer " onClick={() => triggerResetPasswordLink()} >
          <ODIcon src="/assets/lock.svg" height="24px" width="24px" alt="" />
          Reset Password
        </div>
        <p className="text-xs text-gray-500 px-2 ">{user_details.userName}</p>
      </div>
    </div>
    </>
  );
}
